import hariData from "~/data/appsInfo/harigame.json";
import { useFontStyle } from "~/hook/useFontStyle";
import { useLanguageParams } from "~/hook/useLanguageParams";
import { cn } from "~/lib/utils";
import { FALLBACK_IMAGE_ALT_TEXT, LANG } from "~/utils/constant";

export default function HariGameInfo() {
  const lang = useLanguageParams();
  const { appInfo, descriptions } = hariData;
  const { normalInter } = useFontStyle();

  return (
    <div className="w-full max-md:px-3 md:w-1/2 flex flex-col gap-5 text-textSecondaryColor">
      {/* Gujarati Description */}
      {lang === LANG.gujarati && (
        <div>
          <p className={cn("body_text_m mb-2", normalInter)}>{descriptions.gujarati.greeting}</p>
          <p className={cn("body_text_m mb-2 font-semibold", normalInter)}>{descriptions.gujarati.title}</p>
          {descriptions.gujarati.content.map((paragraph, index) => (
            <p key={index} className={cn("body_text_m mb-2", normalInter)}>
              {paragraph}
            </p>
          ))}
        </div>
      )}

      {/* English Description */}
      {lang === LANG.english && (
        <div>
          {/* <p className={cn("mb-4 body_text_m", normalInter)}>
            <strong className={cn("text-textColor body_text_m", normalInter)}>{descriptions.english.title}</strong>
          </p> */}
          {descriptions.english.content.map((paragraph, index) => (
            <p key={index} className={cn("mb-2 body_text_m", normalInter)}>
              {paragraph}
            </p>
          ))}
        </div>
      )}

      {/* App Download Section */}
      <div className="w-full flex flex-col gap-4 items-center mb-5">
        <img
          src={appInfo.icon}
          alt={appInfo.name || FALLBACK_IMAGE_ALT_TEXT}
          title={appInfo.name || FALLBACK_IMAGE_ALT_TEXT}
          className="max-w-full h-auto select-none"
        />
        <span className={cn("text-center font-medium body_text_m", normalInter)}>{appInfo.downloadText}</span>
        <div className="flex gap-4">
          <a href={appInfo.downloadLinks.playStore.url} target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity">
            <img
              src={appInfo.downloadLinks.playStore.image}
              alt={appInfo.downloadLinks.playStore.alt || FALLBACK_IMAGE_ALT_TEXT}
              title={appInfo.downloadLinks.playStore.alt || FALLBACK_IMAGE_ALT_TEXT}
              className="select-none"
            />
          </a>
          <a href={appInfo.downloadLinks.appStore.url} target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity">
            <img
              src={appInfo.downloadLinks.appStore.image}
              alt={appInfo.downloadLinks.appStore.alt || FALLBACK_IMAGE_ALT_TEXT}
              title={appInfo.downloadLinks.appStore.alt || FALLBACK_IMAGE_ALT_TEXT}
              className="select-none"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
